<div class="text-panel" [innerHTML]="text"></div>
